import {KMDGameAssets} from "../KMDGameAssets";
import {gsap} from "gsap";
import {KennethMustDie} from "../KennethMustDie";

export class KMDAdditionalFSAward extends PIXI.Container {

    private readonly _item: PIXI.BitmapText;

    constructor() {
        super();

        this._item = new PIXI.BitmapText("", {
            fontName: KMDGameAssets.BITMAP_FONT_WIN_CAP,
            fontSize: 40
        });
        this._item.visible = false;
        this._item.position.set(360, 200);
        this._item.anchor = new PIXI.Point(0.5, 0.5);

        this.addChild(this._item);
    }

    public showAdditionalFS(val: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        this._item.alpha = 0;
        this._item.visible = true;

        this._item.text = "+" + val;

        tl.to(this._item, {
            duration: 0.2,
            alpha: 1
        });
        tl.add(() => {
            KennethMustDie.keypadPlugin.setZeroBetSpinCounter(KennethMustDie.model.gameData.freespinsLeft);
        });

        tl.to(this._item, {
            duration: 0.1,
            alpha: 0
        }, 0.4);
        tl.add(() => {
            this._item.visible = false;
            this._item.alpha = 1;
        });
        tl.to(this, {
            duration: 0.2
        });

        return tl;
    }
}